import { render, staticRenderFns } from "./creditreports.vue?vue&type=template&id=423207d4"
import script from "./creditreports.vue?vue&type=script&lang=js"
export * from "./creditreports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports